<template>
  <div class="formType">
    <el-select v-if="type == 'select'" v-model="select">
      <el-option v-for="item in formItem.value" :key="item.name" :value="item.name" :label="item.name"></el-option>
    </el-select>
    <el-input v-if="type == 'text'" v-model="text" :placeholder="formItem.placeholder"></el-input>
    <el-date-picker v-if="type=='date'" type= "date" :placeholder="formItem.placeholder" v-model="date"></el-date-picker>
    <el-date-picker v-if="type=='datetime'" type= "datetime" :placeholder="formItem.placeholder" v-model="datetime"></el-date-picker>
    <el-input v-if="type == 'textarea'" type="textarea" v-model="textarea" :placeholder="formItem.placeholder"></el-input>
    <el-date-picker v-if="type=='birthday'" type= "date" placeholder="选择出生日期" v-model="birthday"> </el-date-picker>
    <!-- 性别 -->
    <sex v-if="type == 'sex'"/>
    <!-- 层次 -->
    <level v-if="type == 'level'" />
    <!-- 专业 -->
    <subject v-if="type == 'subject'"/>
    <!-- 政治面貌 -->
    <political-status v-if="type == 'politicalStatus'" />
    <!-- 证件类型 -->
    <card-type v-if="type == 'cardType'"/>
    <!-- 民族 -->
    <nation v-if="type == 'nation'" />
    <!-- 省 -->
    <province v-if="type == 'province'"></province>
    <!-- 省/市 -->
    <province v-if="type == 'provinceCity'" :hasCity="true"></province>
    <!-- 就读院校 -->
    <school v-if="type == 'school'"  />
    <!-- 教学点 -->
    <station v-if="type == 'station'"  />
    <!-- 上传图片 -->
    <image-upload  v-if="type == 'imageUpload'" :fileTypeList="formItem.fileBack" :remarks="formItem.remarks" :filesize="Number(formItem.filesize)"/>
    <!-- 编辑按钮等 -->
    <slot></slot>
  </div>
</template>

<script>
import Level from '@/components/form/Level.vue'
import Subject from '@/components/form/Subject.vue'
import School from '@/components/form/School.vue'
import Station from '@/components/form/Station.vue'
import PoliticalStatus from '@/components/form/PoliticalStatus.vue'
import CardType from '@/components/form/CardType.vue'
import Nation from '@/components/form/Nation.vue'
import Province from '@/components/form/Province/Province.vue'
import Sex from '@/components/form/Sex.vue'
import ImageUpload from '@/components/form/ImageUpload.vue'
// import Level from '../../../../components/form/Level.vue'
// type 自定义表单类型 select下拉框 date短日期 datetime 长日期  text文本框  textarea多行文本 province省 provinceCity省、市 birthday出生日期 subject专业 nation民族 politicalStatus政治身份 imageUpload上传图片
export default {
  name: 'formType',
  components: { Level, Subject, School, Station, PoliticalStatus, CardType, Nation, Province, Sex, ImageUpload },
  props:{
    formItem: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      birthday: '',
      text: '',
      textarea: '',
      datetime: '',
      date: '',
      select: ''
    }
  },
  computed: {
    type() {
      return this.formItem.type ? this.formItem.type : 'text'
    },
    
  },
}
</script>

<style>
.formType{
  display: flex;
  align-content: center;
}
</style>